export default __webpack_public_path__ + "static/media/008-circle-purple.ce8e28ca.svg";